import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'testMessage'
const verb = 'post'

export default class OspreySendRecepients extends BaseAction {
    constructor(dataKey) {
        const id = '63ea2022-bb3e-45a0-b5c7-93ff92131597'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    send(params) {
        this.params = params
        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/test-message/template-send-email.js